var swal = require('sweetalert2');
var AjaxController = require('../../services/AjaxController');

/**
 * Helper
 */
var helper = require('../../helper'),
    dataTables_buttons = [
        {
            extend: 'csv',
            text: 'Export as CSV',
            exportOptions: {
	            columns: '.data-export-csv'
            },
        },
        {
            extend: 'pdf',
            text: 'Export as PDF',
            exportOptions: {
	            columns: '.data-export-pdf',
            },
	        orientation: 'landscape'
        },
        {
            extend: 'print',
            text: 'Print table',
            exportOptions: {
	            columns: '.data-export-print'
            }
        },
        {
            extend: 'colvis',
        }
    ],
    dataTables_columns_export = [
        {data: 'salutation', name:'users.salutation', title: 'Salutation', visible: false, className: 'data-export-csv'},
        {data: 'job_title', name:'users.job_title', title: 'Job Title', visible: false, className: 'data-export-csv'},
        {data: 'address_1', name:'users.address_1', title: 'Address 1', visible: false, className: 'data-export-csv'},
        {data: 'address_2', name:'users.address_2', title: 'Address 2', visible: false, className: 'data-export-csv'},
        {data: 'address_3', name:'users.address_3', title: 'Address 3', visible: false, className: 'data-export-csv'},
        {data: 'town', name:'users.town', title: 'Town', visible: false, className: 'data-export-csv'},
        {data: 'postcode', name:'users.postcode', title: 'Postcode', visible: false, className: 'data-export-csv'},
        {data: 'hearAbout', name:'hearAbout', title: 'Hear About', visible: false, className: 'data-export-csv'},
        {data: 'phone_number', name:'users.phone_number', title: 'Phone number', visible: false, className: 'data-export-csv'},
        {data: 'mobile_number', name:'users.mobile_number', title: 'Mobile number', visible: false, className: 'data-export-csv'},
        {data: 'nationality', name:'nationality', title: 'Nationality', visible: false, className: 'data-export-csv'},
        {data: 'guardian_religion', name:'guardian_religion', title: 'Religion', visible: false, className: 'data-export-csv'},
        {data: 'guardianGender', name:'guardianGender', title: 'Gender', visible: false, className: 'data-export-csv'},
        {data: 'guardianDateOfBirth', name:'guardianDateOfBirth', title: 'Date of birth', visible: false, className: 'data-export-csv'},
        {data: 'nationalInsuranceNumber', name:'nationalInsuranceNumber', title: 'National Insurance Number', visible: false, className: 'data-export-csv'},
        {data: 'on_newsletter_list', name: 'on_newsletter_list', title: 'On newsletter list', visible: false, className: 'data-export-csv'},
        {data: 'on_voluntary_work_list', name: 'on_voluntary_work_list', title: 'On voluntary work list', visible: false, className: 'data-export-csv'},
	    {data: 'assigned_on', name: 'assigned_on', title: 'Assigned on', orderable: false, searchable: false, visible: false, className: 'data-export-csv'},
	    {data: 'officer', name: 'officer', title: 'Officer', visible: false, searchable: false, className: 'data-export-csv'},
	    {data: 'emails_receive_marketing', name: 'emails_receive_marketing', searchable: false, visible: false, className: 'data-export-csv data-export-pdf data-export-print'},
	    {data: 'emails_updates_by', name: 'emails_updates_by', searchable: false, visible: false, className: 'data-export-csv data-export-pdf data-export-print'},
	    {data: 'emails_share_data_other_organisations', name: 'emails_share_data_other_organisations', searchable: false, visible: false, className: 'data-export-csv data-export-pdf data-export-print'},
        {data: 'placed_date', name: 'placed_date', title: 'Placed Date', searchable: false, visible: false, className: 'data-export-csv'},
        {data: 'rent_end_date', name: 'rent_end_date', title: 'End Date', searchable: false, visible: false, className: 'data-export-csv'},
        {data: 'date_notice', name: 'date_notice', title: 'Notice Date - NTQ', searchable: false, visible: false, className: 'data-export-csv'},
        {data: 'createdAt', name: 'createdAt', title: 'Created At', searchable: false, visible: false, className: 'data-export-csv'},
        {data: 'updatedAt', name: 'updatedAt', title: 'Updated At', searchable: false, visible: false, className: 'data-export-csv'},
    ]

$(function() {
    var $datatable = $('#datatable-all-guardians'),
    $dt;
    var  filters = {
        locations: []
    };

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "stateSave": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "stateSaveCallback": function(settings,data) {
            localStorage.setItem( 'DataTables_newVersion_' + settings.sInstance, JSON.stringify(data) );
            localStorage.setItem('DataTables_all_guardians_status_id', $('input[name="clickedStatusId"]').val() );
        },
        "stateLoadCallback": function(settings) {
            return JSON.parse( localStorage.getItem( 'DataTables_newVersion_' + settings.sInstance ) )
        },
        "ajax": {
           "url": helper.getOrigin() + "/api/guardians",
           "method": 'POST',
            "data": function ( d ) {
               d.status_id = (localStorage.getItem('DataTables_all_guardians_status_id'))
                   ? localStorage.getItem('DataTables_all_guardians_status_id') :
                   $('input[name="clickedStatusId"]').val();

               d.custom_filters = filters;
            }
        },
        "autoWidth" : false,
        "buttons": dataTables_buttons,
        "order": [[ 0, "asc" ]],
        "columns": [
            {data: 'unique_guardian_number', name: 'unique_guardian_number', className: 'data-export-csv data-export-pdf data-export-print'},
            {data: 'name', name: 'name', className: 'data-export-csv data-export-pdf data-export-print'},
	        {data: 'statusName', name: 'statusName', className: 'data-export-csv data-export-pdf data-export-print'},
	        {data: 'email', name:'users.email', title: 'E-mail', className: 'data-export-csv data-export-pdf data-export-print'},
            {data: 'notes', name: 'notes', className: 'data-export-csv data-export-pdf data-export-print'},
            {data: 'payment_confirmed', name: 'payment_confirmed', visible: false, searchable: false, className: 'data-export-csv data-export-pdf data-export-print'},
            {
                data: 'actions',
                name: 'actions',
                visible: true,
                orderable: false,
                searchable: false,
                className : "action"
            }
        ].concat(dataTables_columns_export),
        "initComplete": function(settings, json) {


        },
	    'columnDefs': [{
		    'targets': 4,
		    'searchable':true,
		    'orderable':false,
		    'className': 'dt-body-center tiny-column',
		    'render': function (data, type, full, meta){
		        if (data[2] !== null && data[3] !== null) {
                    return '<textarea id="notes-'+data[0]+'" rows="5" cols="75" type="text" name="notes[]" class="js-guardians-change-field" data-guardian='+data[0]+' data-field="notes">'+data[1]+'</textarea>' +
                        '<span class="pull-left" style="font-size: smaller;"><i>Last edited by '+ data[2] +' at '+ data[3] +'</i></span>';
                } else {
                    return '<textarea id="notes-'+data[0]+'" rows="5" cols="75" type="text" name="notes[]" class="js-guardians-change-field" data-guardian='+data[0]+' data-field="notes">'+data[1]+'</textarea>' +
                        '<span class="pull-left" style="font-size: smaller;"><i>Last edited by</i></span>';;
                }
		    }
	    }]
    });

    $('.js-guardian-activity-box').on('click', function() {
        var $this = $(this),
            $clickedStatusId = $('input[name="clickedStatusId"]'),
            statusId = $(this).data('status_id')
            paymentColumn = $dt.column(5);

        $clickedStatusId.val(statusId);

        var valueToDisplay = $(this).children('.activity-title').data('to_display');
        $('#guardian-status-span').text( 'Guardians of "' + valueToDisplay + '" status' );


        if (statusId == 4) {
            paymentColumn.visible(true);
        } else {
            paymentColumn.visible(false);
        }

        localStorage.setItem( 'DataTables_newVersion_' + $dt.settings.sInstance, JSON.stringify( $dt.data ) );
        localStorage.setItem( 'DataTables_all_guardians_status_id', $('input[name="clickedStatusId"]').val() );

        $dt.ajax.reload();
    });

    $('select[name="locations"]').change(function () {
        filters.locations = $(this).val()
        $datatable.DataTable().draw();
    })

    $dt.on('click', 'td', function () {
        var old = $(this).html();
        var cell = $dt.cell(this);

        $(document).on('change', '.js-guardians-change-field', function(e){

            var $this = $(this);
            var guardianId = $this.data('guardian'),
                field = $this.data('field'),
                value = $this.val();
            var url = '/api/guardians/change-field-on-guardian';

            var data = {
                field: field,
                guardianId: guardianId,
                value: value
            };
            var success = function (response) {
                console.log('Success');
            }
            var error = function (response) {
                console.log('Error');
            }

            e.preventDefault();

            swal({
                title: "Are you sure you want to save changes?",
                text: "",
                type: "warning",
                showCancelButton: true
            }).
            then(function (result) {
                if (result.value) {
                    AjaxController.prototype.send(url, data, success, error);
                    cell.data(data).draw();
                } else {
                    cell.data(old).draw();
                }
            })
        });
    });
});
